import { render } from "./RolesView.vue?vue&type=template&id=022a4e50&scoped=true"
import script from "./RolesView.vue?vue&type=script&lang=js"
export * from "./RolesView.vue?vue&type=script&lang=js"

import "./RolesView.vue?vue&type=style&index=0&id=022a4e50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022a4e50"]])

export default __exports__